var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSecurity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 .5a24.3 24.3 0 0 1-8.45 2.445L1 3v6.072a11 11 0 0 0 7.521 10.435L10 20l1.479-.493A11 11 0 0 0 19 9.072V3l-.55-.055A24.3 24.3 0 0 1 10 .5m7.4 3.932A25.9 25.9 0 0 1 10 2.275a25.9 25.9 0 0 1-7.4 2.157v4.64a9.4 9.4 0 0 0 6.427 8.917l.973.325.973-.325A9.4 9.4 0 0 0 17.4 9.072z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.066 7.566 9 13.63l-3.066-3.065 1.132-1.132L9 11.37l4.934-4.935z",
  clipRule: "evenodd"
})));
export default SvgSecurity;